const config = {
    locale: 'ru',
    baseUrl: 'http://195.38.162.132:8880/api/',
    siteTitle: 'GAUGI',
    noAvatarUrl: '/images/no-avatar.png',
    noImageUrl: '/images/no-image.png',
    isProduction: false,
    mode: 'local',
    moreData: '/json/data.php',
    admin_url: 'http://172.16.9.113:81'
}

switch (location.hostname) {
    case '172.16.9.113':
        config.baseUrl = 'http://172.16.9.113:80/api/'
        config.isProduction = false
        config.moreData = 'https://rent.page.kg/json/data.php'
        config.admin_url = 'http://172.16.9.113:81'
        break
    case '195.38.162.132':
        config.baseUrl = 'http://195.38.162.132:8880/api/'
        config.isProduction = false
        config.moreData = 'https://rent.page.kg/json/data.php'
        config.admin_url = 'https://172.16.9.114:81'
        break
    case 'mammulk.gov.kg':
        config.baseUrl = 'https://mammulk.gov.kg/api/'
        config.isProduction = false
        config.moreData = 'https://rent.page.kg/json/data.php'
        config.admin_url = 'https://admin.mammulk.gov.kg/'
        break
    default:
        config.isProduction = false
        break
}
export default config

